import cx from 'classnames';
import { Select } from 'components/Form/Select';
import LanguageDropdown from 'components/LanguageDropdown';
import { Typo } from 'components/Layout';
import session from 'lib/session';
import { useNotifications } from 'modules/notifications/hooks';
import { useEffect } from 'react';
import { componentFromProp, defaultProps } from 'recompose';
import ActionButton from './ActionButton';
import Notifications from './Notifications';
import styles from './styles.css';

const onSelectMerchant = (merchantId) => {
  window.location.href = `${window.location.origin}?merchantId=${merchantId}`;
};

const Divider = () => <div className={styles.divider} />;

const Item: any = defaultProps({ className: styles.item, component: 'div' })(
  componentFromProp('component')
);

const Header = ({
  title,
  role,
  user,
  merchants,
  merchantId,
  signOut,
  onUpgradeClick,
  shouldDisplayUpgradeLink,
  isTest,
  platform,
  createdAt,
  isPrivateShopify,
  merchantID,
}: IHeaderProps) => {
  const { create } = useNotifications();
  /* MAINTENANCE MESSAGE */
  useEffect(() => {
    if (!session.kcToken) {
      create({
        title: 'IMPORTANT MESSAGE: Update your login now!',
        text: `You are using a legacy login which is being retired. You should have received an email regarding the new improved and safer login. If you haven't, please contact yourfriends@findify.io and our support shall setup the new login for you.`,
        type: 'info',
        permanent: true,
      });
    }
  }, []);

  return (
    <header className={cx(styles.root, styles.isNew)}>
      <div className={styles.wrap}>
        <ActionButton />
        <div className={styles.container}>
          <div className={styles.pageTitleWrapper}>
            <Typo.Title size="large" className={styles.pageTitle}>
              {title}
            </Typo.Title>
            {isTest && (
              <div className={styles.testPrefix}>test environment</div>
            )}
          </div>

          <div className={styles.divider} />
          <LanguageDropdown customStyles={styles.languageSelector} />
          {(user.merchants.length > 1 && (
            <Select
              className={styles.merchantSelector}
              style={{ width: 360, padding: '0 15px' }}
              searchable
              allowCreate
              size="small"
              options={merchants}
              value={String(merchantId)}
              onCreate={onSelectMerchant}
              onChange={onSelectMerchant}
            />
          )) || (
            <div className={styles.storeName}>
              {user.merchants[0].merchantName}
            </div>
          )}

          <Notifications />
        </div>
      </div>
    </header>
  );
};

export default Header;

export type IHeaderProps = {
  title: string;
  role: string;
  user: any;
  merchants: any[];
  merchantId: number;
  signOut?: () => void;
  onUpgradeClick?: () => void;
  shouldDisplayUpgradeLink?: boolean;
  shouldDisplayCollections?: boolean;
  shouldDisplayRecommendations?: boolean;
};
